<template>
  <div v-if="isVisible" class="loader-overlay">
      <div class="loader"></div>
      <span class="text" v-html="text"></span>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: { type: Boolean, required: true },
    text: { type: String, required: false, default: '' }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/components/loader';

</style>
